// RecordDetailPage.tsx

import React from "react";
import CustomMenu from "../../components/CustomMenu/CustomMenu";
import { RecordDetailContainer } from "./RecordDetailContainer";
import { useLocation, useParams } from "react-router-dom";

/**
 * 申請詳細ページコンポーネント
 * - URLパラメータから申請IDを取得し、詳細コンテナを表示する
 * - 前画面からの申請データ・ファイルを受け取り引き継ぐ
 */
export const RecordDetailPage = () => {
  const { id } = useParams(); // 申請IDをURLから取得
  const location = useLocation(); // 前の画面のデータ取得用
  const previousApplicationData = location.state?.applicationData ?? null;
  const applicationFiles = location.state?.applicationFiles ?? null;
  const imageFiles = location.state?.imageFiles ?? null;
  return (
    <CustomMenu>
      <RecordDetailContainer
        applicationEntryId={id?? ""}
        previousData={previousApplicationData} 
        previousApplicationFile={applicationFiles}
        imageFiles={imageFiles} />
    </CustomMenu>
  );
};

export default RecordDetailPage;
